import { render } from "./MobileHeaderComponent.vue?vue&type=template&id=d396bd84&scoped=true"
const script = {}

import "./MobileHeaderComponent.vue?vue&type=style&index=0&id=d396bd84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d396bd84"]])

export default __exports__